export default "__VITE_ASSET__KJOnXMK1__"